import * as TabsPrimitive from "@radix-ui/react-tabs";
import classes from "./Tabs.module.scss";
import { clsx } from "clsx";
import { TabsTriggerProps } from "./TabsTriggerProps";

export function TabsTriggerMinimal(props: TabsTriggerProps) {
  const { children, className, ...rest } = props;

  return (
    <TabsPrimitive.Trigger
      className={clsx(classes.triggerMinimal, className)}
      {...rest}
    >
      {children}
    </TabsPrimitive.Trigger>
  );
}
